import dateFormat from "dateformat";
function OrderLogItemView(props) {
  return (
    <tbody>
      <tr>
      <td width={200}>
        <div className={`status${props.STATUS_ID}`}>{props.STATUS}</div>
        </td>
        <td width={200}> {dateFormat(props.EVENT_DATE, "dd-mmm-yy h:MM:ss TT")}
        <br/>{props.DATE_TEXT}</td>

        <td width={120}>
          <b>{props.USERNAME}</b>
        </td>
       
        <td>{props.REVISED_COLUMNS} </td>
        <td>{props.REMARK}</td>
      </tr>
    </tbody>
  );
}
export default OrderLogItemView;
